import { UserAccuseritemModel, UserAccuserModel } from "../../view-models/conferencing";

export class UserDetailAboutCourtFeesApisModel {
    prefix: string = ''
    firstName: string = ''
    lastName: string = ''
    address: string = ''
    moo: number = 0;
    soi: string = '';
    road: string = '';
    province: string = ''
    district: string = ''
    subDistrict: string = ''
    zipCode: string = ''
    contactNumber: string = ''
    fax: number = 0
    email: string = ''
    occupation: number = 0

    capital: number = 0

    idCardNumber!: number;
    BehindIdCardNumber!: string;

    day: number = 0
    mont: number = 0
    year: number = 0
}


export class AboutCourtFeesApisModel {
    reQ_ID: number = 0
    filingAS: number = 0
    filingaS_DOCS: number = 0
    items: AboutCourtFeesItemApisModel[] = []
}
export class AboutCourtFeesItemApisModel {
    groupId: number = 0
    accId: number = 0
}

export class inputPaymentApiModel {
    checkBill: number = 2
    choosePayment: number = 0
    paymentOption: number = 0
    statusCourtFees: number = null!
    refCode: string = null!
    filingDate: Date = new Date
    prefixName: string = ''
    firstName: string = ''
    lastName: string = ''
    day: string = ''
    mouth: string = ''
    year: number = null!
    userAccuser: PayUserAccuserApiModel = new PayUserAccuserApiModel
    plaintiffs: UserAccuserPaymentitemApiModel[] = []
    prosecutors: UserAccuserPaymentitemApiModel[] = []
    sumCapital: number = 0;
    sumFee: number = null!;
    seq: number = 1;
    selected = false;
    submitted = false;
    inAppealCase = false
    payCase: number = null!
    combinePayDate: Date = new Date
    combinePayCompleteDate: Date = new Date
    combinePayStatus: number = null!
    confirm = false
    paymentRefCode1: number = null!;
    paymentRefCode2: number = null!;
    courtBankAccount: string = null!
    courtBankAccountNo: number = null!
    bankAgency: string = null!
    additionalPay: AdditionalPaymentDetailApiModel[] = []

}

export class PayUserAccuserApiModel {
    suiT_ACC_DATE!: Date
    suiT_BLACK_NO!: number
    suiT_RED_NO!: number
    suiT_BLACK_YEAR!: string
    suiT_RED_YEAR!: string
    courtName!: string
    secCode!: string
    items: UserAccuserPaymentitemApiModel[] = []
}

export class UserAccuserPaymentitemApiModel {

    groupId: number = 0
    groupName: string = ''
    accName: string = ''
    accId: number = 0
    capital: number = 0;
    fee: number = null!;
    preCapital: number = 0
    preFees: number = 0
    payCompleteDate: Date = new Date
    payDate: Date = new Date
    payStatus: number = null!
    seq: number = 0
}

export class PaymentCourtFeesApiModel {
    caseId: number = 0
    billId: number = 0
    suitFeeType: number = 0
    refCode: string = ''
    payCode: string = ''
    payCode1: string = ''
    payCode2: string = ''
    payDate: Date = null!
    payInvNo: number = null!
    payMethod: number = 0
    payToTal: number = 0
    amount: number = 0
    payUserName: string = ''
    email: string = ''
    genQrCode: string = ''
    courtName: string = ''
    title: string = ''
    name1: string = ''
    name2: string = ''
}

export class SummaryPaymentDetailApiModel {
    checkBill: number = 2
    choosePayment: number = 0
    paymentOption: number = 0
    statusCourtFees: number = null!
    refCode: string = null!
    filingDate: Date = new Date
    prefixName: string = ''
    firstName: string = ''
    lastName: string = ''
    sumCapital: number = 0
    sumFee: number = 0
    combinePayDate: Date = new Date
    combinePayCompleteDate: Date = new Date
    combinePayStatus: number = null!
    userAccuser: PayUserAccuserApiModel = new PayUserAccuserApiModel
    plaintiffs: UserAccuserPaymentitemApiModel[] = []
    prosecutors: UserAccuserPaymentitemApiModel[] = []
    additionalPay: AdditionalPaymentDetailApiModel[] = []

}

export class AdditionalPaymentDetailApiModel {
    checkBill: number = 2
    choosePayment: number = 0
    paymentOption: number = 0
    payDate: Date = new Date
    sumCapital: number = 0
    sumFee: number = 0
    plaintiffs: UserAccuserPaymentitemApiModel[] = []

}






export class PayCourtFeeDetailApisModel {
    payMethod: number = null!
    suitFeeType: number = null!
    suitFeeStatus: number = null!
    SuitFeeTypeIndictment: number = null!//คำเหนือวิธีชำระเงิน

    refCode: string = ''
    toDayDate: Date = null!
    eAppealDate: Date = null!
    suitAccUser: string = ''
    suitAccUsed: string = ''
    titleText: string = ''
    isSuitFeeType: boolean = false

    courtName: string = ''
    suitBlackNo: number = null!
    suitBlackYear: number = null!
    suitRedNo: number = null!
    suitRedYear: number = null!
    suitBlackText: string = ''
    suitRedText: string = ''
}

export class PayCourtFeeApisModel {
    cId: number = 0
    secId: number = 0
    suitId: number = 0
    addFeeId: number = 0

    caseId: number = 0
    courtName: string = ''
    secName: string = ''
    suitTypeAbbr: string = ''
    payCode: string = ''
    isPayTotal: boolean = false
    isPayTotalDone: boolean = false
    totalPayStatusText: string = ''
    totalPayDate: Date = null!
    accList: AccListPayModelApis[] = []
    suitBlackNo:number= null!
    suitBlackYear:string= ''
    suitRedNo:number= null!
    suitRedYear:string= ''
    appId: number = 0
}

export class AccListPayModelApis {
    caseId: number = 0
    accId: number = 0
    accFeeId: number = 0
    payMentId: number = 0
    titName: string = ''
    accName: string = ''
    accSurName: string = ''
    accCapital: number = 0
    accFee: number = 0
    payStatus: number = 0
    payStatusText: string = ''
    payDate: Date = null!
    payCode: string = ''
    submitted: boolean = false
    groupName: string = ''
}

export class GetBillApiModel {
    paidStatus: number = null!
    suitTypeAbbr: string = ''
    caseId: number = 0
    billId: number = 0
    accId: number = 0
    suitFeeType: number = 0
    refCode: string = null!
    courtName: string = null!
    suitBlackNo: number = 0
    suitBlackYear: string = null!
    suitRedNo: number = 0
    suitRedYear: string = null!
    payCode1: string = null!
    payCode2: string = null!
    payDate: Date = null!
    payMethod: number = 0
    payToTal: number = 0
    payUserName: string = null!
    paySubject: string = null!
    isAppeal:boolean = false
    addFeeId:number = 0
}

export class genBillPdfApiModel {
    kind: string = ''
    id: number = 0
    originalName: string = ''
    storeName: string = ''
    mimeType: string = ''
    extension: string = ''
    sizeInBytes: number = 0
    url: string = ''
    upLoadDate: Date = null!
    upLoadBy: string = ''
    pageNumber: number = 0
    pageStart: number = 0
    pageEnd: number = 0
    urlByName: string = ''
    isGaruda: boolean = true
}

export class PaymentCheckApiModel{
    suitId:number = 0
    isExist:boolean = null!
    isCurrent:boolean = null!
}

export class RefCodeCheckApiModel{
    isExitBlackNo:boolean = null!
    isSuitOwner:boolean = null!
    isPayment:boolean = null!
}

export class saveAppealPayApiModel{
    addFeeId: number = 0
    appId: number = 0
}
